var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialPodcast = function SvgSocialPodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 1.4c-.2.2-.2.6 0 .7s.6.1.7-.1c.4-.4.8-.6 1.2-.8C8.8 1 9.4.9 10 .9s1.2.1 1.9.4c.5.2.9.5 1.2.8.1.1.4.2.6.1s.4-.5.1-.8c-.3-.4-.8-.6-1.4-.9C11.6.1 10.9 0 10 0S8.4.1 7.6.5c-.5.3-1 .5-1.4.9zM7.5 4.2c-.1-.1-.2-.4 0-.5.2-.2.6-.5 1-.8s1-.4 1.5-.4 1.1.1 1.6.4c.4.1.6.4.9.8.1.1.1.5-.1.6-.1.1-.4 0-.5-.1-.2-.2-.5-.4-.6-.5-.4-.1-.9-.2-1.3-.2s-.9.1-1.2.2c-.2.2-.4.3-.7.5-.1.2-.4.3-.6 0zM10 5.2C9 5.2 8.2 6 8.2 7v4.4c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8V7c0-1-.8-1.8-1.8-1.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.6c0-.2-.2-.4-.4-.4-.4-.1-.5.2-.5.4v1.7c0 2 1.5 3.6 3.5 3.9v2.6H7.9c-.2 0-.4.2-.4.4s.1.5.4.5h4.4c.2 0 .4-.2.4-.4s-.3-.3-.5-.3h-1.9v-2.6c2-.2 3.5-1.9 3.5-3.9V9.6c0-.2-.2-.4-.4-.4s-.4.2-.4.4v1.7c0 1.6-1.4 3-3 3s-3-1.4-3-3V9.6z"
  })));
};
export default SvgSocialPodcast;